import { useLocalisation } from "@3plearning/lingui-cdn";
import React, { useState } from 'react';
import { Button } from "@3plearning/react-components";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { activateModal, dismissModal } from "../../../containers/modal-manager/modal-manager-actions";
import css from "../footer-popup/footer-popup.scss";
import AssignDateModal from "./assign-date-modal";

import AssignButtonWrapper from "./styled";

import OutsideClickHandler from "../../../helpers/hoc/close/outside-click-handler";
import useManageAssignments from "../../../helpers/hooks/use-manage-assignments";
import { AssignIcon, IconAssignLater } from "../../../helpers/icon-dictionary";
import { ASSIGN_DATE_MODAL_ID } from "../helpers";

import { 
  groupAssignAndUnAssignAssignmentsSelector,
  selectIsAssigningOrUnAssigning
} from '../selectors';

import getTranslations from '../translations';

import FooterPopup from "../footer-popup";

const assignPopupOpenDefaultState = false;
const assignButtonId = 'assignButton';

const AssignButton = () => {
  const { i18n } = useLocalisation();
  const {
    ASSIGN_BUTTON_TEXT,
    ASSIGN_LATER_TEXT,
    MODIFY_ASSIGN_DATES_TEXT,
    ASSIGN_NOW_TEXT
  } = getTranslations({ i18n });

  const dispatch = useDispatch();

  const [assignPopupOpen, setAssignPopupOpen] = useState(assignPopupOpenDefaultState);

  const isAssigningOrUnAssigning = useSelector(selectIsAssigningOrUnAssigning);
  const { assignmentsToAssign } = useSelector(groupAssignAndUnAssignAssignmentsSelector);
  const previewModal = useSelector(state => state.modalContainerReducer, shallowEqual);
  const assignAssignmentCount = assignmentsToAssign.length;

  const { assignAssignments } = useManageAssignments();

  const onAssignClickHandler = () => setAssignPopupOpen(prevState => !prevState);
  const onSubmit = async (startDate = null, dueDate = null) => {
    await assignAssignments({
      studentAssignments: assignmentsToAssign,
      startDate,
      dueDate
    });

    setAssignPopupOpen(false);
    dispatch(dismissModal());
  }
  const onOutsideClickHandlerCallback = () => {
    const isDisplayingModal =
      previewModal.length > 0 &&
      previewModal[0].id === ASSIGN_DATE_MODAL_ID;

    if (!isDisplayingModal) setAssignPopupOpen(assignPopupOpenDefaultState);
  }

  const options = [
    {
      icon: IconAssignLater,
      title: ASSIGN_LATER_TEXT,
      description: MODIFY_ASSIGN_DATES_TEXT,
      onClickHandler: () => dispatch(activateModal({
        content: <AssignDateModal callback={onSubmit} />,
        id: ASSIGN_DATE_MODAL_ID,
        buttons: [],
        className: css['modal-override']
      })),
      disabled: false
    },
    {
      icon: AssignIcon,
      title: ASSIGN_NOW_TEXT,
      description: null,
      onClickHandler: () => onSubmit(),
      disabled: false
    }
  ];

  return (
    <>
      <OutsideClickHandler
        callback={() => onOutsideClickHandlerCallback()}
        forButton={assignButtonId}
      >
        <AssignButtonWrapper>
          <Button
            className="button"
            id={assignButtonId}
            disabled={assignAssignmentCount === 0 || isAssigningOrUnAssigning}
            primary
            text={ASSIGN_BUTTON_TEXT(assignAssignmentCount)}
            type={Button.LOZENGE}
            onClick={() => onAssignClickHandler()}
            alignIcon="LEFT"
            icon={AssignIcon}
          />
          <FooterPopup
            isOpen={assignPopupOpen}
            onSubmit={onSubmit}
            options={options}
          />
        </AssignButtonWrapper>
      </OutsideClickHandler>
    </>
  )
}

export default AssignButton;